import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { StyledMainProduct } from '../styles';
import { TooltipRenderer } from 'components/TooltipTemplate/TooltipRenderer';
import { IProductResponse } from 'utils/types';
import {
  EDynamicBundleType,
  MAIN_PRODUCT_TOOLTIP_BUTTON_STYLES,
  ADVANCED_TOOLTIP_STYLES,
  SIMPLE_TOOLTIP_STYLES,
} from '../constants';

export const MainProduct: React.FC<{
  mainProduct: any;
  salePercentage?: number;
  tooltipLoadCallback?: (arr: string[]) => Promise<IProductResponse[]>;
  tooltipOpenEventHandler?: () => void;
  tooltipIcon: string;
  bundleType: EDynamicBundleType;
}> = ({
  mainProduct,
  salePercentage = 0,
  tooltipLoadCallback,
  tooltipOpenEventHandler,
  tooltipIcon,
  bundleType,
}) => {
  return (
    <StyledMainProduct className="main-product">
      <div className="product-img">
        <img className="image" src={mainProduct.images.product} alt="product" />
      </div>
      <div className="content-container">
        <div className="quantity-container">
          <AutoTextSize
            as="div"
            mode="oneline"
            maxFontSizePx={14}
            minFontSizePx={6}
            className="quantity-container__value"
          >
            {mainProduct.quantityDisplay}
            <TooltipRenderer
              product={mainProduct}
              tooltipLoadCallback={tooltipLoadCallback}
              tooltipOpenEventHandler={tooltipOpenEventHandler}
              advancedTooltipStyle={ADVANCED_TOOLTIP_STYLES[bundleType]}
              simpleTooltipStyle={SIMPLE_TOOLTIP_STYLES[bundleType]}
              buttonStyle={MAIN_PRODUCT_TOOLTIP_BUTTON_STYLES}
            >
              <img
                className="tooltip-icon"
                src={tooltipIcon}
                alt="tooltip-icon"
              />
            </TooltipRenderer>
          </AutoTextSize>
        </div>
        {salePercentage > 0 && (
          <div className="stroked-container">
            <AutoTextSize
              as="div"
              mode="oneline"
              maxFontSizePx={10}
              minFontSizePx={6}
              className="stroked-container__value"
            >
              {mainProduct.strokedSaleQuantity}
            </AutoTextSize>
          </div>
        )}
      </div>
    </StyledMainProduct>
  );
};
